import { request } from './index';

export const uploadFileApi = {
	uploadFileInfo: '/files/preupload', //文件预上传
	uploadFileData: (id: string) => `/files/part/${id}/upload`, //文件上传,可分块上传
	uploadFileState: (id: string) => `/files/${id}/files`, //查看文件上传完的状态
	getFileData: (id: string) => `/files/${id}/get`,
};

/**
 * 文件预上传
 */
export const uploadFileInfo = (params: {}): Promise<IFile> => {
	return new Promise((resolve) => {
		request(uploadFileApi.uploadFileInfo, { body: params }).then((res) => {
			resolve((res as unknown) as IFile);
		});
	});
};

/**
 * 文件上传, 可分片上传
 */
export const uploadFileData = (id: string, params: {}): Promise<IFile> => {
	return new Promise((resolve) => {
		request(uploadFileApi.uploadFileData(id), params).then((res) => {
			resolve((res as unknown) as IFile);
		});
	});
};

/**
 * 查看文件上传完的状态
 */
export const uploadFileState = (id: string): Promise<IFile> => {
	return new Promise((resolve) => {
		request(
			uploadFileApi.uploadFileState(id),
			{ body: { id: '311eb187f01142a19cb47f205a5ada59' } },
			'get',
		).then((res) => {
			resolve((res as unknown) as IFile);
		});
	});
};

/**
 * 查看文件上传完的状态
 */
export function getFileData(id: string) {
	return new Promise((resolve) => {
		request(uploadFileApi.getFileData(id), { body: { id } }, 'get').then((res) => {
			resolve(res);
		});
	});
}
